import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { siteConfig } from "@/config";

export const Route = createFileRoute("/contact-us")({
  head: () => ({
    meta: [
      { title: `Contact Us | ${siteConfig.siteName}` },
      {
        name: "description",
        content: `Contact the ${siteConfig.siteName} editorial team with feedback, corrections, or partnership inquiries.`,
      },
      { property: "og:title", content: `Contact ${siteConfig.siteName}` },
      { property: "og:url", content: `${siteConfig.domain}/contact-us` },
    ],
    links: [{ rel: "canonical", href: `${siteConfig.domain}/contact-us` }],
  }),
  component: ContactPage,
});

function ContactPage() {
  const [sent, setSent] = useState(false);
  return (
    <section className="mx-auto max-w-2xl px-4 py-14">
      <h1 className="text-4xl font-bold tracking-tight text-foreground">Contact us</h1>
      <p className="mt-3 text-muted-foreground">
        Questions, feedback, corrections, or partnership inquiries — send us a note and we'll get
        back to you within two business days.
      </p>

      {sent ? (
        <div className="mt-8 rounded-lg border border-primary/30 bg-primary/5 p-6 text-sm text-foreground">
          Thanks — your message has been received. We'll reply as soon as possible.
        </div>
      ) : (
        <form
          className="mt-8 space-y-4"
          onSubmit={(e) => {
            e.preventDefault();
            setSent(true);
          }}
        >
          <div>
            <label htmlFor="name" className="mb-1 block text-sm font-medium text-foreground">
              Your name
            </label>
            <input
              id="name"
              required
              className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/30"
            />
          </div>
          <div>
            <label htmlFor="email" className="mb-1 block text-sm font-medium text-foreground">
              Email address
            </label>
            <input
              id="email"
              type="email"
              required
              className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/30"
            />
          </div>
          <div>
            <label htmlFor="message" className="mb-1 block text-sm font-medium text-foreground">
              Message
            </label>
            <textarea
              id="message"
              rows={6}
              required
              className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/30"
            />
          </div>
          <button
            type="submit"
            className="rounded-md bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground hover:bg-primary/90"
          >
            Send message
          </button>
        </form>
      )}

      <div className="mt-10 border-t border-border pt-6 text-sm text-muted-foreground">
        You can also reach us by email at{" "}
        <a href={`mailto:${siteConfig.contactEmail}`} className="text-primary hover:underline">
          {siteConfig.contactEmail}
        </a>
        .
      </div>
    </section>
  );
}
